import { getBondChatSocket } from "./bondchat/generalChatSingleton";
import { prependActivity } from "./activitySlice";
import { patchAppUser } from "./appAuthSlice";
import {
  applyDashboardWalletBalances,
  fetchDashboardTxAnalytics,
} from "./dashboardSlice";

const ACTIVITY_LISTENER_KEY = "__activityPulseListener";
const WALLET_LISTENER_KEY = "__walletBalanceListener";

/** Live Bond Pulse rows when someone you follow posts a P2P offer. */
export const initializeActivitySocketListeners = (dispatch, socketOverride) => {
  const socket = socketOverride || getBondChatSocket();
  if (!socket) return;

  if (!socket[ACTIVITY_LISTENER_KEY]) {
    socket[ACTIVITY_LISTENER_KEY] = true;
    socket.on("activity:new", (payload) => {
      const activity = payload?.activity;
      if (!activity?._id) return;
      dispatch(prependActivity(activity));
    });
  }

  if (!socket[WALLET_LISTENER_KEY]) {
    socket[WALLET_LISTENER_KEY] = true;
    socket.on("walletBalanceUpdated", (payload) => {
      const cash = payload?.CASH;
      const coin = payload?.COIN;
      if (cash == null && coin == null) return;

      const patch = {};
      if (cash != null) patch.CASH = cash;
      if (coin != null) patch.COIN = coin;
      dispatch(patchAppUser(patch));
      dispatch(applyDashboardWalletBalances(patch));

      const userId = payload?.userId;
      if (userId) {
        dispatch(fetchDashboardTxAnalytics({ userId, force: true }));
      }
    });
  }
};
